export function deduplicateDiagnosisCategoriesByName<
  TCategory extends { name: string }
>(categories: readonly TCategory[]): TCategory[] {
  const seenNames = new Set<string>();

  return categories.filter((category) => {
    if (seenNames.has(category.name)) return false;
    seenNames.add(category.name);
    return true;
  });
}
